/* eslint-disable new-cap */
import Vue from 'vue';
import { debounce } from 'lodash';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

Vue.component('masonry-grid-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            grid: null,
            msnry: null,
            masonryOptions: {},
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.$nextTick(() => {
            this.masonryInit();
        });

        this.$parent.$on('masonry-reload', () => {
            this.msnry.layout();
        });
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.resizeMsnryInit.bind(this));
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        masonryInit() {
            this.grid = this.$el.querySelector('.masonry-grid') || this.$el;
            this.masonryOptions = {
                itemSelector: '.masonry-grid__item',
                columnWidth: '.card',
                percentPosition: true,
                gutter: 20,
            };

            // eslint-disable-next-line no-new
            new imagesLoaded(this.grid, () => {
                this.msnry = new Masonry(this.grid, this.masonryOptions);
            });

            window.addEventListener('resize', debounce(this.resizeMsnryInit.bind(this)));
        },
        resizeMsnryInit() {
            this.msnry.layout();
        },
        updateMasonry() {
            this.msnry.reloadItems();
            imagesLoaded(this.grid, () => {
                this.msnry.layout();
            });
        },
    },
});
